// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileProtectOutlinedSvg from "@ant-design/icons-svg/es/asn/FileProtectOutlined";
import AntdIcon from '../components/AntdIcon';

var FileProtectOutlined = function FileProtectOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileProtectOutlinedSvg
  }));
};

FileProtectOutlined.displayName = 'FileProtectOutlined';
export default React.forwardRef(FileProtectOutlined);